module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-800.8f065219.eot";